export default __webpack_public_path__ + "static/media/VinodLogo.ef0bbcf8.webp";